<template>
  <note-list
    :is-fetching="uiFlags.isFetching"
    :notes="notes"
    @add="onAdd"
    @delete="onDelete"
    @note-content-changed="$emit('note-content-changed', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import NoteList from './components/NoteList';

export default {
  components: {
    NoteList,
  },
  props: {
    contactId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ uiFlags: 'contactNotes/getUIFlags' }),
    notes() {
      return this.$store.getters['contactNotes/getAllNotesByContact'](
        this.contactId
      );
    },
  },
  mounted() {
    this.fetchContactNotes();
  },
  methods: {
           showAlert(message,  action = {}) {
      bus.$emit('newToastMessage', message, action);
    },

    fetchContactNotes() {
      const { contactId } = this;
      if (contactId) this.$store.dispatch('contactNotes/get', { contactId });
    },
    onAdd(content) {
      const { contactId } = this;
      this.$store.dispatch('contactNotes/create', { content, contactId });
    },
  async onDelete(noteId) {
      const { contactId } = this;
      
      try {
         const response = await this.$store.dispatch('contactNotes/delete', { noteId, contactId });
         if(response.status === 200){
           this.showAlert("Note deleted successfully", { success: true });
         }
      } catch (error) {
        this.showAlert("Please try again", { success: false });
      }
    },
  },
};
</script>
